import { render, staticRenderFns } from "./AuthView_VerifyEmail.vue?vue&type=template&id=54a8c56e&"
import script from "./AuthView_VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./AuthView_VerifyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports